import { writable } from 'svelte/store';
import {Catalog} from "./entities/Catalog";

export const selectedId = writable(null);
export const catalog = writable(Catalog);